import { size } from "polished";
import styled from "styled-components";
import BaseDreamTeam from "../../img/icons/dreamteam.svg?react";

const DreamTeam = styled(BaseDreamTeam)`
  ${size(14)};
  color: white;
  fill: #005baa;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

export default DreamTeam;
